<template>
  <div>
    <el-menu
      class="el-menu "
      mode="horizontal"
      background-color="#545c64"
      text-color="#fff"
      active-text-color="#ffd04b"
    >
      <el-row>
        <el-col :span="18">
          <el-menu-item index="1" @click="$router.push('/')">Admin</el-menu-item>
        </el-col>
        <el-col :span="4">
          <el-menu-item index="3">{{ user.name }}</el-menu-item>
        </el-col>
        <el-col :span="2">
          <el-menu-item index="2" @click="logout()">Выйти</el-menu-item>
        </el-col>

      </el-row>


    </el-menu>
  </div>
</template>

<script>
export default {
  name: "Navbar",
  data: function () {
    return {}
  },
  mounted() {
  },
  computed: ({
    user() {
      return this.$store.state.User.currentUser;
    },
    check() {
      return this.$store.getters.check;
    }
  }),
  methods: {
    async logout() {
      // Log out the user.
      await this.$store.dispatch('logout')

      // Redirect to login.
      await this.$router.push({path: '/login'})
    },
  },
}
</script>

<style scoped>

</style>